import React from 'react';
import {Row, Col} from 'react-bootstrap'
import {renderTestFields} from '../../../constants'

const ReportTestView = ({test}) => {

    const fields = renderTestFields(test)

    //console.log('TestView', test)

    const style = {}
    if (fields.aircraft.length > 4) {
        //style.height = '40px' //expand cell if needed
    }

    return (
        <Row className="test-row" style={style}>
            <Col className="test-cell test-cell-left" xs={1} style={style}>
                {fields.ref}
            </Col>
            <Col className="test-cell" xs={2} style={style}>
                {fields.startedAt}
            </Col>
            <Col className="test-cell" xs={2} style={style}>
                {fields.schedulerName}
            </Col>
            <Col className="test-cell" xs={1} style={style}>
                {fields.aircraft}
            </Col>
            <Col className="test-cell" xs={1} style={style}>
                {fields.aircraftRegistration}
            </Col>
            <Col className="test-cell" xs={1} style={style}>
                {fields.power}
            </Col>
            <Col className="test-cell" xs={2} style={style}>
                {fields.departure}
            </Col>
            <Col className="test-cell" xs={2} style={style}>
                {fields.status}
            </Col>
        </Row>
    )
}

export default ReportTestView


// WEBPACK FOOTER //
// ./src/components/admin/report/ReportTestView.jsx